import React, { useState, useEffect } from "react";
import { Card, Row, Col, Table, Statistic, Tag } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { PieChart, Pie, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, LineChart, Line, Legend } from "recharts";
import Dashboard from "./components/Dashboard";
import { TrackerDashboard } from "./components/bdetracker/TrackerDashboard";
import BDEPerformanceChart from "./components/bdetracker/BDEPerformanceChart";
import { Tracker } from "./components/bdetracker/Tracker";
import BDETrackerDashboard from "./components/bdetracker/BDETrackerDashboard";
import OverviewDashboard from "./components/bdetracker/OverviewDashboard";
import AverageDeploymentSummary from "./components/bdetracker/AverageDeploymentSummary";
import dayjs, { Dayjs } from "dayjs";
import { useSelector } from "react-redux";

const BDETracker = () => {
    const [selectedBDE, setSelectedBDE] = useState<string | null>(null);
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [selectedPeriod, setSelectedPeriod] = useState<string>('month');

    const { user, isGlobalAdmin } = useSelector((state: any) => state.app);
    const isAdmin = isGlobalAdmin || user?.designation === 'Admin';

    useEffect(() => {
        // Set default dates on mount
        const today = dayjs();
        setStartDate(today.startOf('month'));
        setEndDate(today.endOf('month'));
    }, []);

    return (
        <div className="">
            <TrackerDashboard
                onFiltersChange={(filters: any) => {
                    setSelectedBDE(filters.bdeId);
                    setStartDate(filters.startDate);
                    setEndDate(filters.endDate);
                    setSelectedPeriod(filters.period);
                }}
            />
            <BDEPerformanceChart
                bdeId={selectedBDE}
                startDate={startDate}
                endDate={endDate}
                period={selectedPeriod}
            />
            <Tracker
                bdeId={selectedBDE}
                startDate={startDate}
                endDate={endDate}
                period={selectedPeriod}
            />
            <BDETrackerDashboard />
            <OverviewDashboard
                bdeId={selectedBDE}
                startDate={startDate}
                endDate={endDate}
                period={selectedPeriod}
            />
            <AverageDeploymentSummary
                bdeId={selectedBDE}
                startDate={startDate}
                endDate={endDate}
                period={selectedPeriod}
            />
        </div>
    );
};

export default BDETracker;
